import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';

declare var math: any;

@Injectable({
	providedIn: 'root'
})
export class NumberSciQualifierService implements Qualifier {
	static supportedStats = ['avg', 'count', 'first', 'last', 'max', 'median', 'min', 'sum', 'stddev'];
	static ToString(value: number, format: CastingTypeFormat, precision: number = 4, noHTML = false): string {

		const config = {}

		if ([undefined, null, ''].indexOf('' + value) > -1) {
			return '';
		}
		if (typeof value === 'string') {
			value = Number(value);
		}
		switch (format) {
			default:
			case 'sci':
				return '' + value.toExponential(precision).trim();
			case 'sci-eng':
				const parts = math.format(value, { notation: 'engineering' }).trim().toLowerCase().split('e');
				const numParts = parts[0].split('.');
				const left = numParts[0];
				const right = numParts.length > 1 ? '.' + Number('.' + numParts[1]).toFixed(precision).split('.').pop() : '';
				const exp = (parts[1] === '+0') ? '' : 'E' + parts[1];
				return `${left}${right}${exp}`;
				break;
			case 'sci-pow':
				if (noHTML === true) {
					return '' + value.toExponential(precision).replace(/[eE](.+)/, ' x 10^$1').replace('+', '').trim();
				} else {
					return '' + value.toExponential(precision).replace(/[eE](.+)/, ' x 10<sup>$1</sup>').replace('+', '').trim();
				}
		}
	}
	static FromString(value: string, format: CastingTypeFormat): number {
		switch (format) {
			default:
			case 'sci':
				return Number(value);
			case 'sci-eng':
				return Number(value);
			case 'sci-pow':
				return Number(value.replace(/ x 10\<sup\>(\d+)\<\/sup\>/, 'E$1'));
		}
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any, noHTML: boolean = false): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberSciQualifierService.ToString(val, casting.format, casting.precision, noHTML);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if ([undefined, null, ''].indexOf(val) > -1) {
			return '';
		}
		return NumberSciQualifierService.GetDisplayValue(attribute, castingMode, val, true);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return NumberSciQualifierService.FromString(value, attribute.casting[castingMode].format);
	}
	public static SupportsStat(statName): boolean {
		return NumberSciQualifierService.supportedStats.indexOf(statName) > -1;
	}

	constructor() { }
}
